module.exports = __webpack_public_path__ + "static/media/801Hou.9dc32e6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/801Hou.png
// module id = 1690
// module chunks = 0 1